import TableReportHelper from "report/helper"

import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport"
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport"
import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport"
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport"

export default async function lcReport(indicador, visita) {
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor

    const apontamentos = visita.getApontamentosByIndicador(indicador)

    const content = []

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const configIndicador = {
            showTrator: false,
            showImplemento: false,
            showFrente: false,
            addHeaderField: [
                {
                    field: "talhao.area",
                    label: "Área do Talhão (ha)",
                    width: 90,
                    valueGetter: (a) => {
                        let sumArea = 0

                        if (a.talhao.length) {
                            for (let i = 0; i < a.talhao.length; i++) {
                                sumArea = sumArea + parseFloat(a.talhao[i].area)
                            }

                            return sumArea.toFixed(2)
                        } else {
                            return a.talhao.area
                        }
                    },
                },
                { field: "totalNumAdultas", label: "Total Adultas", width: 70 },
                {
                    field: "numAdultasMetro",
                    label: "Adultas/Metro",
                    width: 70,
                    secondConformidadeField: (a) => {
                        return {
                            conformidade: "numAdultasMetro",
                            status: IndicadorClass.getConformidadeStatus(
                                a.numAdultasMetro,
                                params.metaMaxAdultas,
                                null,
                                visita.cliente
                            ),
                            config: { alignment: "right" }
                        }
                    }
                },
                { field: "totalNumNinfas", label: "Total Ninfas", width: 70 },
            ]
        }

        content.push(
            [
                await apontamentoHeaderLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    params,
                    "Ninfas/Metro", // label da conformidade
                    configIndicador,
                ),

                await apontamentoColetasLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    ["Nº de Ninfas", "Nº de Adultas"],
                    // prettier-ignore
                    (h) => [
                        h.numberField("numNinfas"),
                        h.numberField("numAdultas"),
                    ],
                    [60, 60]
                ),
                apontamentoImagesReport(visita, indicador, apontamento),
                apontamentoObservacaoReport(visita, indicador, apontamento),

                h.space(),
            ]
        )
    }

    return content
}
